import posthog from "posthog-js";

type EventParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * GA4 + PostHog 동시 이벤트 전송
 */
export function trackEvent(eventName: string, params?: EventParams) {
  const cleanParams = params ? Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined)) : undefined;

  // GA4 (gtag)
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, cleanParams);
  }

  // PostHog
  if (posthog.__loaded) {
    posthog.capture(eventName, cleanParams);
  }
}
